import React from 'react'

import { SEND_STATUS, UNKNOWN_LEVEL_TONE } from '../helpers/constants'
import { fmtResetAt } from '../helpers/helper'

/* The `Can send` cell: the send-state badge, plus (when rate-limited) the moment cocloud's
 * own Redis daily window naturally clears.
 *
 * This column reflects cocloud's own sender-pool rate limiter — the same Redis state that
 * gates real sends — so "can send" is authoritative, not inferred from past SMTP errors.
 */
const SendStatusCell = ({ send }) => {
  if (!send) {
    return <span className='am-muted'>—</span>
  }

  // An unrecognised level still renders, as a neutral badge showing the raw string — a new
  // backend state should look unfamiliar, not disappear.
  const status = SEND_STATUS[send.level]
  const tone = status ? status.tone : UNKNOWN_LEVEL_TONE
  const label = status ? status.label : send.level
  const isRateLimited = send.canSend === false && send.level === 'rate_limited'
  const resetAt = isRateLimited ? fmtResetAt(send.dailyResetAt) : ''

  return (
    <div className='am-send-cell'>
      {/* The text label carries the meaning; the colour and dot only reinforce it. */}
      <span className={`am-badge am-badge-${tone}`}>{label}</span>
      {send.detail ? <div className='am-send-detail'>{send.detail}</div> : null}
      {resetAt ? <div className='am-send-detail'>{`Resets ${resetAt}`}</div> : null}
    </div>
  )
}

export default SendStatusCell
